module.exports = __webpack_public_path__ + "static/media/P5.6966d493.jpg";